// extracted by mini-css-extract-plugin
export default {"icon":"GoBackSection_icon__MsgHT"};